export function sortSelectOptionsAscending(options) {
  return options.slice().sort((a, b) => {
    const nameA = a.name ?? '';
    const nameB = b.name ?? '';
    return nameA.localeCompare(nameB, undefined, {
      sensitivity: 'case',
      caseFirst: 'lower'
    });
  });
}
